export default "__VITE_ASSET__BOwQn_Rg__"